import { Button, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import OnboardingEndImage from '~/apps/consumer/images/signup/onboarding-end.svg';
import { SVGComponent } from '~/common/components/SVGComponent';

interface ProcessingContractsProps {
  title: string;
  description: string;
  ctaButtonText?: string;
  onCTAClick?: () => void;
}

export const ProcessingContracts: FC<ProcessingContractsProps> = ({
  title,
  description,
  ctaButtonText,
  onCTAClick,
}) => {
  return (
    <VStack
      alignItems="center"
      flexGrow={1}
      height="100%"
      justifyContent="center"
      px={4}
    >
      <VStack spacing={1}>
        <Text color="white" fontSize="32px" textAlign="center">
          {title}
        </Text>
        <Text
          color="whiteAlpha.500"
          fontSize="18px"
          textAlign="center"
          whiteSpace={{ base: 'normal', md: 'pre' }}
        >
          {description}
        </Text>
      </VStack>

      {ctaButtonText && onCTAClick ? (
        <Button mt={6} zIndex={1} onClick={onCTAClick}>
          {ctaButtonText}
        </Button>
      ) : null}

      <VStack mt={{ base: '0px', md: '-130px' }} position="relative" zIndex={0}>
        <SVGComponent url={OnboardingEndImage} />
      </VStack>
    </VStack>
  );
};
